export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
};

export const HTTP_STATUS_MESSAGE = {
  OK: "OK",
  ACCEPTED: "ACCEPTED",
  FAILED: "FAILED",
  ERROR: "ERROR",
  UNAUTHORIZED: "UNAUTHORIZED",
  CREATED: "CREATED",
};

export const Permissions = {
  TASK_UPDATE: "TASK_UPDATE",
  LEAD_VIEW: "LEAD_VIEW",
  TASK_VIEW: "TASK_VIEW",
  LEAD_CREATE: "LEAD_CREATE",
  LEAD_UPDATE: "LEAD_UPDATE",
  DASHBOARD_VIEW: "DASHBOARD_VIEW",
  LEAD_ASSIGN: "LEAD_ASSIGN",
  CREATE_EMPLOYEE: "CREATE_EMPLOYEE",
  REPORT_VIEW: "REPORT_VIEW",
};
